import * as React from "react";
import IAccessoryAccordionPropsType from "./IAccessoryAccordionProps";
// import DownArrow from "../../../assets/images/review-down-red.png";
// import UpArrow from "../../../assets/images/review-up-red.png";
import "../../../assets/sass/widgets/accessoryAccordion.scss";
import { handleEnter, setSessionValue, getSessionValue, imagePathurl } from "../../utils/utils";
interface IAccessoryAccordionStateType {
    showAccordion: boolean;
}

/**
 * @class AccessoryAccordionWidget
 * @description
 * This component acts as an Accordion widget
 * @category Widget
 */
class AccessoryAccordionWidget extends React.Component<IAccessoryAccordionPropsType, IAccessoryAccordionStateType, {}> {
    constructor(props: IAccessoryAccordionPropsType) {
        super(props);
        this.state = {
            showAccordion: false,
        };
    }
    componentDidMount() {
        const sessionValue = getSessionValue("accordions");
        if (!sessionValue) {
            setSessionValue("accordions", []);
        }
        if (sessionValue && sessionValue.indexOf(this.props.id) > -1) {
            if (document.getElementById(this.props.id)) {
                this.setState({ showAccordion: true });
            }
        }
    }
    collapseAccordion = (): void => {
        const { id } = this.props;
        const sessionValues = getSessionValue("accordions");
        this.setState({ showAccordion: !this.state.showAccordion }, () => {
            if (sessionValues.indexOf(id) < 0 && this.state.showAccordion) {
                sessionValues.push(id);
            }
            if (sessionValues.indexOf(id) >= 0 && !this.state.showAccordion) {
                const index = sessionValues.indexOf(id);
                if (index > -1) {
                    sessionValues.splice(index, 1);
                }
            }
            setSessionValue("accordions", sessionValues);
        });
    };
    render() {
        const { schema, id, children, classNames } = this.props;
        const { showAccordion } = this.state;
        const getimagePath = imagePathurl();
        
        const containerCss =
            classNames.indexOf("accessory-accordion-container") !== -1
                ? "accessory-accordion-colorbg-box"
                : "accessory-accordion-box";
        return (
            <>
                <div key={id} className={classNames}>
                    <div
                        id={id}
                        className="accessory-accordion-label-container"
                        onKeyPress={handleEnter}
                        tabIndex={schema.const.tabIndex}
                        onClick={this.collapseAccordion}
                    >
                        <img className="accessory-accordion-icon" src={showAccordion ? `${getimagePath}review-up-red.png` : `${getimagePath}review-down-red.png`} />
                        <span className="accessory-accordion-label">{schema.const.description}</span>
                    </div>
                    {showAccordion && <div className={containerCss}>{children}</div>}
                </div>
            </>
        );
    }
}
export default AccessoryAccordionWidget;
